import { render } from "./ClWordLeft.vue?vue&type=template&id=d9fec0ca"
import script from "./ClWordLeft.vue?vue&type=script&lang=js"
export * from "./ClWordLeft.vue?vue&type=script&lang=js"

import "./ClWordLeft.vue?vue&type=style&index=0&id=d9fec0ca&lang=scss"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__